import { FilterOption } from '../interfaces/FilterOption';
import BaseService from './base.service';
import MapToFilterOptions from '../helpers/mapToFilterOption';

class SitesService {
  public static getAllByParams(column?: string, inputValue?: string): Promise<FilterOption[]> {
    return BaseService.getAllByParams('sites', column, inputValue)
      .then((sites) => {

        return MapToFilterOptions.mapToFilterOptions(sites);
      }).catch((error: Error) => {
        throw error;
      });
  }
}

export default SitesService;
